import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import mapTick from "../../../asset/images/maptick.svg"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { partner_Admin } from "../../../Configuration/Partner_URL";
import { toast } from "react-toastify";
import SmallLoader from "../../Common/smallLoader";
import { decryptData, encryptData } from "../../../CommonMethhods/CommonMethods";
import { axiosSsoText } from "../../../CommonMethhods/axiosPartnerInterceptor";


function PartnerMapClient(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const errorMsg = props.errorMsg;
  const partnerDetails = props.partnerDetails;
  const [deleteTransaction, setDeleteTransaction] = useState(false);
  const [mapSuccessModal, setMapSuccessModal] = useState(false);
  const [loader, setLoader] = useState(false);
  

  const deleteMapModal = () => {
    setDeleteTransaction(false);
    setMapSuccessModal(true);
  };
  const schema = yup.object().shape({
    clientCode: yup.string().required("Enter client code"),
  });
  const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
    resolver: yupResolver(schema),
  });


  const mapClientData = async (clientId) => {
    setLoader(true);
    let payloadReq = {
      pCode: partnerDetails?.partnerCode,
      clientId: clientId?.clientCode,
  }
  let payloadApproved = encryptData(JSON.stringify(payloadReq));
  
    try {
      const getDetail = await axiosSsoText.post(
        partner_Admin.Get_MapClient_Url,
        payloadApproved,
      );
      const mapingResp = decryptData(getDetail?.data);
      let decryptedMapinResp = JSON.parse(mapingResp);
      if(decryptedMapinResp?.status === 0){
        // getPartnerId();
        toast.success(decryptedMapinResp?.data?.message);
      }else{
        toast.error(decryptedMapinResp?.message);
      }
      
    } catch (error) {
      console.log(error);
    }
    finally{
    setLoader(false);

    }
  };


  const handleProceedBtn=(data)=>{
      mapClientData(data);
      
    reset();
  }
  

  return (
    <>
      <div className="card-box">
        <div className="card-title">
          <h3>Map Client</h3>
        </div>
        <form onSubmit={handleSubmit(handleProceedBtn)}>
          <div className="map-client-box">
            <div>
            <input
              type="text"
              className="form-input text-uppercase"
              placeholder="Enter Client Code"
              autoComplete="off"
              {...register("clientCode")}
              onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;

                  let input = e.target.value.toUpperCase();
                  input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                          input = input.replace(/\s{2,}/g, " "); 
                          input = input.replace(/^\s+/, ""); 

                  if (input.length > 20) input = input.slice(0, 20);
                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                  }}
              // onChange={(e)=>handleInput(e)}

            />
            <div className="invalid-error">{errors.clientCode?.message}</div>
            </div>
            {errorMsg?.length > 0 ? 
            <button
            className="map-proceed"
            type="submit"
            disabled
            // onClick={(e) => handleProceedBtn(e)}
          >
            {loader ?
            <SmallLoader />
              : 
              <>
              Proceed
              </>
          }
            
          </button>
            :
            <button
              className="map-proceed"
              type="submit"
              // onClick={(e) => handleProceedBtn(e)}
            >
              {loader ?
              <SmallLoader />
                : 
                <>
                Proceed
                </>
            }
              
            </button>
            }
          </div>
        </form>
      </div>

      <Modal
        show={deleteTransaction}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model partner-small-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            <h2 className="modal-title">Are you Sure?</h2>
            <p className="modal-desc">
              You want to Map ONLXXXXXX <br />
              Under P700988898
            </p>

            <div className="btn-wrapper">
              <button className="del-btn map-btn" onClick={deleteMapModal}>
                MAP
              </button>
              <button
                className="can-btn"
                onClick={() => setDeleteTransaction(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* User Mapped Successfully */}

      <Modal
        show={mapSuccessModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model partner-small-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            <img src={mapTick} className="arrow-tick" alt="mapTick" />

            <h2 className="modal-title">User Mapped Successfully</h2>

            <div className="btn-wrapper">
              <button
                className="del-btn map-btn"
                onClick={() => setMapSuccessModal(false)}
              >
                Ok
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PartnerMapClient;
